import type { ReactNode } from 'react';
import { Icon } from '../icons/Icon.js';
import type { IconName } from '../icons/registry.js';

type Item<K extends string> = { key: K; label: string; icon?: IconName };

type Props<K extends string> = {
  items: ReadonlyArray<Item<K>>;
  value: K;
  onChange: (k: K) => void;
};

export function SegmentedControl<K extends string>({ items, value, onChange }: Props<K>) {
  return (
    <div className="seg" role="tablist">
      {items.map((it): ReactNode => (
        <button
          key={it.key}
          type="button"
          role="tab"
          aria-selected={value === it.key}
          className={'seg-item' + (value === it.key ? ' active' : '')}
          onClick={() => onChange(it.key)}
        >
          {it.icon && <Icon name={it.icon} size={16} />}
          {it.label}
        </button>
      ))}
    </div>
  );
}
